import React, { useContext } from "react";
import { Container } from "reactstrap";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  PDFDownloadLink,
  PDFViewer,
  Image,
} from "@react-pdf/renderer";
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";
import { Button } from "../Update/style";
import { Root } from "../style";
import { ContactContext } from "../../../../../context/contact/ContactContext";
import { useTranslation } from "react-i18next";

const styles = StyleSheet.create({
  page: {
    padding: 10,
  },
  section: {
    textAlign: "center",
    margin: 10,
    padding: 10,
    flexGrow: 1,
  },
  img: {
    width: 200,
    textAlign: "center",
    margin: "0 auto",
  },
  titulo: {
    fontSize: 30,
    marginTop: 30,
    marginBottom: 30,
    textAlign: "center",
    color: "black",
    fontWeight: "bold",
  },
  Labels: {
    fontSize: 15,
    marginTop: 20,
    textAlign: "left",
    fontWeight: "bold",
  },
  valuesLabels: {},
  LabelsTit: {
    fontSize: 20,
    marginTop: 20,
    textAlign: "left",
    fontWeight: "bold",
  },
  contInfo: {
    marginLeft: 40,
  },
});

const DownloadDocument = () => {
  const { t } = useTranslation();
  const { primaryContact } = useContext(ContactContext);

  const MyDoc = () => (
    <Document>
      <Page style={styles.page}>
        <View style={{ textAlign: "center" }}>
          <Image src="/logo-life.png" style={styles.img} />
        </View>
        <Text style={styles.titulo}>{t("personalDoc")}</Text>
        <View style={styles.contInfo}>
          <View style={{ flexDirection: "row" }}>
            <View style={{ flexDirection: "row", marginRight: "20%" }}>
              <Text style={styles.LabelsTit}>
                {t("name")}:&nbsp;&nbsp;&nbsp;
              </Text>
              <Text style={styles.Labels}>{primaryContact.givenName}</Text>
            </View>
            <View style={{ flexDirection: "row" }}>
              <Text style={styles.LabelsTit}>
                {t("lastName")}:&nbsp;&nbsp;&nbsp;
              </Text>
              <Text style={styles.Labels}>{primaryContact.surname}</Text>
            </View>
          </View>
          <View
            style={{
              flexDirection: "row",
              marginRight: "25%",
            }}
          >
            <Text style={styles.LabelsTit}>
              {t("email")}:&nbsp;&nbsp;&nbsp;
            </Text>
            <Text style={styles.Labels}>
              {
                primaryContact.identities.filter(
                  (x) => x.signInType === "emailAddress"
                )[0].issuerAssignedId
              }
            </Text>
          </View>
        </View>
      </Page>
    </Document>
  );

  return (
    <Root>
      <Container style={{ paddingTop: "30px" }}>
        <PDFViewer style={{ width: "100%" }} height={700} showToolbar={true}>
          <MyDoc />
        </PDFViewer>
      </Container>
      <PDFDownloadLink
        document={<MyDoc />}
        fileName={"DatosPersonales" + primaryContact.surname + ".pdf"}
      >
        {({ blob, url, loading, error }) =>
          loading ? (
            "Loading document..."
          ) : (
            <Button>
              {t("download")}
              <DownloadForOfflineIcon />
            </Button>
          )
        }
      </PDFDownloadLink>
    </Root>
  );
};

export default DownloadDocument;
